// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  googleMapsApiKey: 'AIzaSyCM9f2-q9SyHDRwb2ad6vQoZgY3tHqRASE',
  publicWebBaseUrl: 'https://drinkbevme.com',
  // Development / iOS test builds should point here.
  apiBaseUrl: 'https://bevme-api-dev-hzbefvhdbwajevh3.centralus-01.azurewebsites.net',
  // apiBaseUrl:'https://localhost:7030'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
